(function() {
  const KLAVIYO_PUBLIC_KEY = 'UF487J';
  const KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/api/back-in-stock-subscriptions/';
  const LOW_STOCK_THRESHOLD = 3;

  // What the observer below listens for. Deliberately narrow so Horizon's own
  // re-render triggers us, but our writes (handled via applyState) do not.
  const OBSERVER_CONFIG = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'class', 'aria-checked', 'data-option-available', 'hidden', 'disabled']
  };

  function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

  function setFeedback(f, m, t) {
    if (!f) return;
    f.textContent = m;
    f.style.color = t === 'error' ? '#A32D2D' : t === 'success' ? '#5C1A1F' : '#5F5E5A';
  }

  function getStockMap(picker) {
    const s = picker.querySelector('script[type="application/grandeur-stock"]');
    if (!s) return {};
    try { return JSON.parse(s.textContent.trim()); } catch (e) { return {}; }
  }

  function getQtyForInput(input, picker) {
    const stockMap = getStockMap(picker);
    const vid = input.getAttribute('data-variant-id');
    if (vid && stockMap[vid] !== undefined) return { qty: stockMap[vid], variantId: vid };
    return { qty: null, variantId: null };
  }

  function updateDots(picker) {
    const labels = picker.querySelectorAll('label.variant-option__button-label');
    labels.forEach(function(label) {
      if (label.classList.contains('variant-option__button-label--has-swatch')) return;
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      const info = getQtyForInput(input, picker);
      const isAvailable = input.getAttribute('data-option-available') === 'true';
      const isLow = isAvailable && typeof info.qty === 'number' && info.qty > 0 && info.qty <= LOW_STOCK_THRESHOLD;
      let dot = label.querySelector('.grandeur-low-stock-dot');
      if (isLow && !dot) {
        dot = document.createElement('span');
        dot.className = 'grandeur-low-stock-dot';
        dot.style.cssText = 'position:absolute;top:6px;right:6px;width:7px;height:7px;border-radius:50%;background:#5C1A1F;pointer-events:none;z-index:10;box-shadow:0 0 0 1px #FFF;';
        label.appendChild(dot);
      } else if (!isLow && dot) {
        dot.remove();
      }
    });
  }

  function updateMessages(picker) {
    const lowMsg = picker.querySelector('[data-grandeur-low-stock-message]');
    const notifyMsg = picker.querySelector('[data-grandeur-notify-message]');
    const notifyForm = picker.querySelector('[data-grandeur-notify-form]');
    const checked = picker.querySelector('input[type="radio"]:checked');
    if (!checked) {
      if (lowMsg) lowMsg.style.display = 'none';
      if (notifyMsg) notifyMsg.style.display = 'none';
      if (notifyForm) notifyForm.style.display = 'none';
      return;
    }
    const info = getQtyForInput(checked, picker);
    const isAvailable = checked.getAttribute('data-option-available') === 'true';
    const isLow = isAvailable && typeof info.qty === 'number' && info.qty > 0 && info.qty <= LOW_STOCK_THRESHOLD;
    const isSoldOut = !isAvailable;
    if (lowMsg) lowMsg.style.display = isLow ? 'flex' : 'none';
    if (notifyMsg) notifyMsg.style.display = isSoldOut ? 'flex' : 'none';
    if (notifyForm && !isSoldOut) notifyForm.style.display = 'none';
  }

  // Applies our visual state. It pauses the observer first so that our own DOM
  // writes (showing the message, adding the dot) cannot retrigger the observer
  // and cause an infinite loop. Reconnects in finally so it always recovers.
  function applyState(picker) {
    const obs = picker.__grandeurObserver;
    if (obs) obs.disconnect();
    try {
      updateDots(picker);
      updateMessages(picker);
    } finally {
      if (obs) obs.observe(picker, OBSERVER_CONFIG);
    }
  }

  // Horizon re-renders the picker in several quick steps when a variant is
  // selected. This coalesces that burst into a single apply on the next frame,
  // so we always read the final selected variant rather than an in-between one.
  function scheduleApply(picker) {
    if (picker.__grandeurRaf) return;
    picker.__grandeurRaf = requestAnimationFrame(function() {
      picker.__grandeurRaf = null;
      applyState(picker);
    });
  }

  async function subscribe(email, variantId) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
    const r = await fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(KLAVIYO_PUBLIC_KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15', 'accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
    return true;
  }

  function init(picker) {
    if (picker.__grandeurInit) {
      scheduleApply(picker);
      return;
    }
    picker.__grandeurInit = true;

    // The fix. Watch the picker for any DOM change Horizon makes when a variant
    // is selected, then re-apply our state after it settles. This is what kills
    // the "message disappears on first click" bug: Horizon re-renders the picker
    // just after our update lands and wipes the message. The observer catches
    // that re-render and puts the message back, so it stays in sync on a single
    // click instead of needing a second one.
    picker.__grandeurObserver = new MutationObserver(function() { scheduleApply(picker); });

    // Initial paint plus connect the observer.
    applyState(picker);

    // Still listen for change for an instant response. The observer is the
    // safety net that wins the race against Horizon's async re-render.
    picker.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"]')) scheduleApply(picker);
    });

    const trigger = picker.querySelector('[data-grandeur-notify-trigger]');
    const form = picker.querySelector('[data-grandeur-notify-form]');
    const input = picker.querySelector('[data-grandeur-notify-email]');
    const submit = picker.querySelector('[data-grandeur-notify-submit]');
    const feedback = picker.querySelector('[data-grandeur-notify-feedback]');

    if (trigger && form) {
      trigger.addEventListener('click', function() {
        form.style.display = 'flex';
        setFeedback(feedback, '', null);
        if (input) input.focus();
      });
    }
    if (submit && input) {
      submit.addEventListener('click', async function() {
        const email = (input.value || '').trim();
        if (!isValidEmail(email)) { setFeedback(feedback, 'Please enter a valid email.', 'error'); return; }
        const checked = picker.querySelector('input[type="radio"]:checked');
        if (!checked || checked.getAttribute('data-option-available') === 'true') {
          setFeedback(feedback, 'Please select a sold-out size first.', 'error'); return;
        }
        const info = getQtyForInput(checked, picker);
        if (!info.variantId) { setFeedback(feedback, 'Could not identify size.', 'error'); return; }
        submit.disabled = true;
        setFeedback(feedback, 'Submitting...', null);
        try {
          await subscribe(email, info.variantId);
          setFeedback(feedback, "You're on the list. We'll email you when it returns.", 'success');
          input.value = '';
        } catch (err) {
          console.error(err);
          setFeedback(feedback, 'Something went wrong. Please try again.', 'error');
        } finally { submit.disabled = false; }
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); submit.click(); }
      });
    }
  }

  function bootstrap() {
    document.querySelectorAll('variant-picker').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  // Safety nets for late-mounting pickers on first load.
  setTimeout(bootstrap, 300);
  setTimeout(bootstrap, 1000);
  document.addEventListener('variant:change', bootstrap);
})();